import L from "leaflet";
import markerIconUrl from "@/icons/marker.svg";
import "leaflet/dist/leaflet.css";

document.addEventListener("DOMContentLoaded", () => {
  const mapElement = document.querySelector("#map");
  if (!mapElement) return;

  // New: read markers array from data-markers if present
  let markersData = [];
  try {
    if (mapElement.dataset.markers) {
      markersData = JSON.parse(mapElement.dataset.markers);
    }
  } catch (e) {
    console.warn("Invalid markers JSON on #map.data-markers", e);
  }

  // Backward compatibility: if no markers array, fall back to single lat/lng
  if (!markersData.length) {
    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const popupText = mapElement.dataset.popup || "We are here!";
    if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
      markersData = [{ lat, lng, popup: popupText }];
    }
  }

  // Bail if we still have no coordinates
  if (!markersData.length) return;

  const icon = L.icon({
    iconUrl: markerIconUrl,
    iconSize: [24, 30],
    iconAnchor: [12, 30], // bottom center of a 24×30 icon
    popupAnchor: [0, -30],
  });

  // Start the map centered on the first marker; we'll fit bounds after adding all
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  const first = markersData[0];
  const map = L.map("map", {
    maxZoom: 16,
    scrollWheelZoom: false,
    touchZoom: false,
    dragging: window.innerWidth > 768,
    tap: window.innerWidth > 768,
  }).setView([first.lat, first.lng], 12);

  // Use HTTPS to avoid mixed-content issues
  L.tileLayer(
    "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
  ).addTo(map);

  // Esri reference (labels) layer, free and no API key. CARTO's tiles now
  // require a key and watermark "API KEY REQUIRED".
  L.tileLayer(
    "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}"
  ).addTo(map);

  const group = L.featureGroup();
  markersData.forEach((m, idx) => {
    const marker = L.marker([m.lat, m.lng], { icon }).bindPopup(m.popup || "", {
      className: "leaflet-cta-popup",
      closeButton: false,
      maxWidth: 360,
    });
    group.addLayer(marker);
    if (idx === 0) marker.openPopup();
  });
  group.addTo(map);

  // Small runtime style to make CTA popups feel roomy and remove default white background
  const style = document.createElement("style");
  style.textContent = `.leaflet-cta-popup .leaflet-popup-content{margin:0; background:none; box-shadow:none;} .leaflet-cta-popup .leaflet-popup-content-wrapper{background:none; border:none; box-shadow:none}`;
  document.head.appendChild(style);

  // Event delegation: when CTA button is clicked, select correct filiaal and typeContact
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".leaflet-button");
    if (!btn) return;

    // Select the correct filiaal in the dropdown
    const select = document.querySelector("select[name='fields[filiaal][]']");
    if (select) {
      const filiaalId = btn.dataset.filiaalId;
      if (filiaalId) {
        const opt = Array.from(select.options).find(
          (o) => o.value === filiaalId
        );
        if (opt) {
          select.value = filiaalId;
          select.dispatchEvent(new Event("input", { bubbles: true }));
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    // Check the “Maak een afspraak” radio button
    const radio = document.querySelector(
      "input[type='radio'][name='fields[typeContact]'][value='Maak een afspraak']"
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("input", { bubbles: true }));
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  // Fit to all markers
  if (markersData.length > 1) {
    map.fitBounds(group.getBounds(), { padding: [20, 20], maxZoom: 16 });
  }
});
